import { apiFetch } from "./client";

export interface AgentConversation {
  id: string;
  companyId: string;
  fromAgentId: string;
  toAgentId: string;
  fromAgentName: string;
  fromAgentRole: string;
  toAgentName: string;
  toAgentRole: string;
  sessionKey: string | null;
  createdAt: string;
  /** Most recent message timestamp in the conversation, or null if none yet.
   *  Used by the org chart to flag agent pairs that are actively talking. */
  lastMessageAt: string | null;
  messageCount: number;
}

export interface AgentConversationMessage {
  id: string;
  conversationId: string;
  direction: string;
  content: string;
  metadata: Record<string, unknown> | null;
  createdAt: string;
}

export interface MessageAgentResponse {
  conversationId: string;
  reply: string;
  usage?: Record<string, unknown>;
  model?: string;
}

export const agentConversationsApi = {
  listByCompany: (companyId: string) =>
    apiFetch<AgentConversation[]>(`/companies/${companyId}/agent-conversations`),

  getMessages: (conversationId: string) =>
    apiFetch<{ conversation: AgentConversation; messages: AgentConversationMessage[] }>(
      `/agent-conversations/${conversationId}/messages`,
    ),

  messageAgent: (agentId: string, targetAgentId: string, message: string) =>
    apiFetch<MessageAgentResponse>(`/agents/${agentId}/message-agent`, {
      method: "POST",
      body: JSON.stringify({ targetAgentId, message }),
    }),
};
